import React, { useContext } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import Context from "../../Context";
import CommentForm from "../Blog/CommentForm";
import Modal from "../Modal";

const Comment = props => {
  const context = useContext(Context);
  return (
    <>
      <Row>
        <Card>
          <Card.Body>
            <Row>
              <Col
                style={{
                  fontSize: "12px",
                  color: "#a8a8b3",
                  padding: "5px 0",
                }}>
                <span>{props.data.fullname}</span>
                <span> ({props.data.created_at.ago_str})</span>
              </Col>
            </Row>
            <hr></hr>
            <Row>
              <Col>
                <p>{props.data.body}</p>
              </Col>
            </Row>
            <Row className="justify-content-end">
              {props.dpt <= 0 ? (
                <Button onClick={() => context.modal.show()}>پاسخ</Button>
              ) : (
                ""
              )}
            </Row>
            <Modal>
              <CommentForm
                form_title=" پاسخ"
                comment_id={props.data.id}
                post_id={props.post_id}
                modalClose={props.modalClose}
              />
            </Modal>
          </Card.Body>
        </Card>
      </Row>
      <Row style={{ paddingRight: "10%", marginTop: 10 }}>
        <Col style={{ paddingLeft: 0 }}>
          {props.data.replies.map(comment => (
            <Comment data={comment} dpt={props.dpt + 1} />
          ))}
        </Col>
      </Row>
    </>
  );
};

export default Comment;
